import React from 'react';
import { Message, Icon } from 'semantic-ui-react';

const MurphyInteractionWarning = ({ assessment }) => {
    if (!assessment || assessment.murphyInteractionStatus !== 'ignored' || !assessment.ignoredQuestions) {
        return null;
    }

    return (
        <Message negative icon style={{ marginBottom: '1rem' }}>
            <Icon name="exclamation triangle" />
            <Message.Content>
                <Message.Header>Murphy Questions Ignored - Heavy Penalty Applied</Message.Header>
                <p>
                    Murphy was ready to ask {assessment.ignoredQuestions} question(s) during this session, 
                    but they were ignored or not properly responded to. This results in an automatic score of zero, irrespective of pitch performance.
                </p>
                <p>
                    <strong>Important:</strong> In future sessions, make sure to acknowledge and respond 
                    substantively to Murphy's questions when they are asked to avoid this severe penalty.
                </p>
            </Message.Content>
        </Message>
    );
};

export default MurphyInteractionWarning;